import React from 'react';
import { SegmentedControl } from 'virtues-bootstrap';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { map } from 'ramda';
import { withTranslation } from 'react-i18next';

import s from './styles.module.scss';

const SegmentedNav = ({ items, t }) => (
  <div className={s.navigation} data-test="navigationBlock">
    <SegmentedControl>
      {map(
        ({ to, transKey }) => (
          <NavLink key={to} to={to}>
            {t(transKey)}
          </NavLink>
        ),
        items,
      )}
    </SegmentedControl>
  </div>
);

SegmentedNav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ to: PropTypes.string.isRequired, transKey: PropTypes.string.isRequired }),
  ).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SegmentedNav);
